import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/binding`;

export const memberBindingSa = (bindingInfo) => callApi({
    method: 'POST',
    endpoint: `${basePath}/member-binding-sa`,
    body: bindingInfo
  });

  export const memberChangeBindingSa = (bindingInfo) => callApi({
    method: 'POST',
    endpoint: `${basePath}/member-change-binding-sa`,
    body: bindingInfo
  });
